<div class="flex w-full flex-col" [ngClass]="[containerClassName]">
  <!-- Top Section -->
  @if (title) {
    <div
      class="flex h-full flex-col gap-2.5 rounded-3xl p-6 lg:items-start"
      [ngClass]="[
        sectionClassName,
        alwaysShowShadow
          ? 'shadow-card-top-hover-light'
          : 'group-hover:shadow-card-top-hover-light dark:group-hover:shadow-card-top-hover-dark',
      ]">
      @if (prefixIcon) {
        <div class="w-fit self-center rounded-lg bg-primary p-2.5 lg:self-start">
          <lucide-icon [name]="prefixIcon" size="20" class="text-white" />
        </div>
      }

      @if (prefixIconCustom) {
        <div class="w-fit self-center rounded-lg bg-transparent p-2.5 lg:self-start">
          <span [inlineSVG]="prefixIconCustom" class="text-foreground"></span>
        </div>
      }

      <div class="flex flex-col gap-2 font-medium">
        <span [ngClass]="titleClassName">{{ title }}</span>

        @if (subtitle) {
          <span [ngClass]="subtitleClassName" class="font-medium">{{ subtitle }}</span>
        }
      </div>
    </div>
  }

  <!-- First Middle Section -->
  @if (highlightTitle || description) {
    <div
      class="-mt-[1px] flex h-full flex-col gap-2 rounded-3xl p-6 lg:items-start"
      [ngClass]="[
        sectionClassName,
        alwaysShowShadow
          ? 'shadow-card-bottom-hover-light'
          : 'group-hover:shadow-card-bottom-hover-light dark:group-hover:shadow-card-bottom-hover-dark',
      ]">
      @if (highlightTitle) {
        <div [ngClass]="highlightTitleClassName">{{ highlightTitle }}</div>
      }

      @if (description) {
        <div [ngClass]="descriptionClassName">{{ description }}</div>
      }
    </div>
  }

  <!-- Second Middle Section -->
  @if (listItems) {
    <div
      class="-mt-[1px] flex flex-col items-center gap-2 rounded-3xl p-6"
      [ngClass]="[
        sectionClassName,
        listContainerClassName,
        alwaysShowShadow
          ? 'shadow-card-bottom-hover-light'
          : 'group-hover:shadow-card-bottom-hover-light dark:group-hover:shadow-card-bottom-hover-dark',
      ]">
      @for (item of listItems; track item) {
        <div class="flex w-full gap-2">
          @if (showListItemIcon) {
            @if (isMonochromeListBullet) {
              <span
                [inlineSVG]="'assets/media/icons/checkbox.svg'"
                class="self-center text-foreground [--stroke-color:theme(colors.white)] dark:[--stroke-color:theme(colors.black)]"></span>
            } @else {
              <span [inlineSVG]="'assets/media/icons/check-green-icon.svg'"></span>
            }
          }
          <span class="w-full text-base lg:text-start" [ngClass]="listItemsClassName">{{ item }}</span>
        </div>
      }
    </div>
  }

  <!-- Bottom Section -->
  @if (showButton) {
    <div
      class="-mt-[1px] flex items-center rounded-3xl p-6"
      [ngClass]="[
        sectionClassName,
        alwaysShowShadow
          ? 'shadow-card-bottom-hover-light'
          : 'group-hover:shadow-card-bottom-hover-light dark:group-hover:shadow-card-bottom-hover-dark',
      ]">
      <app-compound-button
        [title]="buttonText"
        [btnVariant]="btnVariant"
        [icon]="buttonIcon"
        (click)="onButtonClick()"></app-compound-button>
    </div>
  }
</div>
